import(/* webpackMode: "eager" */ "/home/runner/work/quiz-platform/quiz-platform/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default","GlobalErrorListener"] */ "/home/runner/work/quiz-platform/quiz-platform/src/components/ui/ErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/quiz-platform/quiz-platform/src/components/ui/FeedbackWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/quiz-platform/quiz-platform/src/components/ui/LangNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/quiz-platform/quiz-platform/src/components/ui/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/quiz-platform/quiz-platform/src/components/ui/RouteTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/runner/work/quiz-platform/quiz-platform/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/runner/work/quiz-platform/quiz-platform/src/contexts/LanguageContext.tsx");
